<template>
  <div class="groupAuth_wrap">
    <div class="groupAuth_left">
      <ioc-table ref="groupTableRef" :data="groupData" :option="constData.groupTable"
        @search-change="(val) => { handleSearchChange(val, 'group'); }"
        @search-reset="(val) => { handleSearchReset('group'); }" @row-click="handleRowClick">
      </ioc-table>
    </div>
    <div class="groupAuth_right">
      <deviceList ref="deviceListRef" :personnelGroupCode="personnelGroupCode" @openSelectDialog="openSelectDialog">
      </deviceList>
    </div>
    <deviceSelect :selectGroup="personnelGroupCode" :showDevicePanel="showDevicePanel"
      @handleCloseDevicePanel="handleCloseDevicePanel"></deviceSelect>
  </div>
</template>

<script>
import { api } from "../api/index";
import { groupTable } from "../config/groupTable";
import deviceList from "./deviceList.vue";
import deviceSelect from "./deviceSelect";
export default {
  name: "groupAuth",
  components: {
    deviceList,
    deviceSelect
  },
  data() {
    return {
      constData: {
        groupTable: groupTable(true),
        groupSearchForm: {},
      },
      groupData: [],
      personnelGroupCode: '',
      showDevicePanel: false
    }
  },
  mounted() {
    this.groupGetList()
  },
  methods: {
    // 查询群组列表
    groupGetList() {
      let params = {
        ...this.constData.groupSearchForm,
      };
      this.$fetch(api.group.queryPersonnelgroup, params).then((res) => {
        if (!res.success) {
          this.$$message.error(res.msgContent || "获取数据失败");
          return;
        }
        this.groupData = res.returnObj;
        let row = { ...this.groupData[0] };
        this.$refs.groupTableRef.$refs.multipleTable.setCurrentRow(row);
        this.handleRowClick(row);
      });
    },
    // 条件搜索
    handleSearchChange(param, type) {
      this.constData[`${type}SearchForm`] = Object.assign({}, param);
      this[`${type}GetList`]();
    },
    // 条件重置
    handleSearchReset(type) {
      this.constData[`${type}SearchForm`] = {};
      this[`${type}GetList`]();
    },
    // 点击群组获取人员
    handleRowClick(row) {
      this.personnelGroupCode = row.personnelGroupCode
      this.personnelGroupName = row.personnelGroupName
      this.$refs.deviceListRef.deviceGetListParent(this.personnelGroupCode, this.personnelGroupName)
    },
    // 按组添加设备
    openSelectDialog() {
      if (this.personnelGroupCode) {
        this.showDevicePanel = true;
      } else {
        this.$message({
          message: '请先选择群组',
          type: 'warning'
        });
      }
    },
    handleCloseDevicePanel() {
      this.showDevicePanel = false;
      this.$refs.deviceListRef.deviceGetList()
    }
  }
}
</script>

<style lang="scss" scoped>
.groupAuth {
  &_wrap {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
  }

  &_left {
    width: 600px;
    height: 100%;
  }

  &_right {
    width: calc(100% - 616px);
    height: 100%;
  }
}
</style>